import styled from "styled-components";
import theme from "../../../../theme";

export const ShopifyBannerBox = styled.div`
  margin-top: 96px;
  margin-bottom: 96px;

  @media (max-width: 426px) {
    margin-bottom: 72px;
  }
`;

export const ShopifyBannerContainer = styled.div`
  max-width: 100%;
  margin: 0 50px;

  @media (max-width: 992px) {
    margin: 0 20px;
  }
`;

export const SubTitle = styled.div`
  font-size: 30px;
  line-height: 39px;
  margin-bottom: 50px;
  margin-top: 57px;
  text-align: center;

  @media only screen and (max-width: 768px) {
    margin-top: 40px;
  }
  @media only screen and (max-width: 480px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const EmailForm = styled.div`
  text-align: center;
  margin-bottom: 96px;

  .gravityform__button {
    background-color: ${theme.black};
    padding: 10px 27px;
    border-radius: 1.875rem;
    color: ${theme.white};
    font-size: 16px;
    line-height: 21rem;
    min-width: 156px;
    display: inline-block;
    text-align: center;
  }

  .gravityform__button:hover {
    color: ${theme.black};
    background-color: #00afaa;
  }

  .hire_email_form form {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .gform_body {
      position: relative;
    }
    .validation_message {
      position: absolute;
      left: 0;
      @media (max-width: 768px) {
        position: unset;
      }
    }
  }
  .hire_email_form form .gravityform__button {
    margin-top: 0;
  }
  .hire_email_form form .gravityform__field__input {
    border: 1px solid #979797;
    border-radius: 30px;
    width: 328px;
    padding: 10px;
    margin-right: 20px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }

  .hire_email_form form .gravityform__field__input::placeholder {
    color: #979797;
    font-family: "Inter", sans-serif;
    opacity: 0.8;
  }

  @media only screen and (max-width: 768px) {
    margin-bottom: 72px;

    .hire_email_form form {
      display: block;
    }

    .hire_email_form form .gravityform__field__input {
      width: 60%;
    }
  }
  @media only screen and (max-width: 575px) {
    .hire_email_form form .gravityform__field__input {
      width: 100%;
    }
  }
`;
